import { useState } from 'react';
import { Star, X } from 'lucide-react';

const APP_STORE_REVIEW_URL = 'https://apps.apple.com/app/id6779376823?action=write-review';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.selahandstone.selahslate';
const MS_STORE_URL = 'https://apps.microsoft.com/detail/9PJF6L5GH0TF';

function detectPlatform() {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  if (/Windows/i.test(ua)) return 'windows';
  return 'desktop';
}

export const RateUsCard = () => {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem('rate_prompt_done') === '1'; } catch (e) { return false; }
  });
  if (hidden) return null;

  const done = () => {
    try { localStorage.setItem('rate_prompt_done', '1'); } catch (e) { /* private mode */ }
    setHidden(true);
  };

  const platform = detectPlatform();
  const links = [];
  if (platform === 'ios') links.push({ label: 'Rate on the App Store', href: APP_STORE_REVIEW_URL });
  else if (platform === 'android') links.push({ label: 'Rate on Google Play', href: PLAY_STORE_URL });
  else if (platform === 'windows') links.push({ label: 'Rate on Microsoft Store', href: MS_STORE_URL });
  else {
    links.push({ label: 'App Store', href: APP_STORE_REVIEW_URL });
    links.push({ label: 'Google Play', href: PLAY_STORE_URL });
  }

  return (
    <div
      className="relative mb-6 p-5 bg-white border border-[#B76E79]/30 rounded-sm animate-fade-in-up text-center"
      data-testid="rate-us-card"
    >
      <button
        onClick={done}
        aria-label="Dismiss review prompt"
        data-testid="rate-us-dismiss"
        className="absolute top-2 right-2 p-1.5 text-[#36454F]/30 hover:text-[#36454F]/60 transition-colors"
      >
        <X className="w-4 h-4" strokeWidth={2} />
      </button>
      <div className="flex justify-center gap-1 mb-2" aria-hidden="true">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-5 h-5 text-[#B76E79] fill-[#B76E79]" strokeWidth={1.5} />
        ))}
      </div>
      <p className="font-['Playfair_Display'] text-lg font-semibold text-[#36454F] mb-1">
        Enjoying Selah Slate?
      </p>
      <p className="text-sm text-[#36454F]/60 font-['Manrope'] mb-4 max-w-md mx-auto">
        A quick rating helps another family find this free tool. It takes 30 seconds and means the world to us. 🙏
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={done}
            data-testid={`rate-us-link-${l.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            className="inline-block px-5 py-2.5 bg-[#B76E79] text-white text-sm font-['Manrope'] font-semibold rounded-sm hover:bg-[#a35d68] transition-colors"
          >
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default RateUsCard;
